import { FC, FormEvent, useState } from 'react';
import { Box, Button, InputIcon, Modal } from '@platform/ui-library';
import { useServices } from '../../hooks';

export const CreateAnchor: FC<any> = ({ context }) => {
  const { appConfigService } = useServices();

  const [isOpen, setIsOpen] = useState(false);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const selectedAnchorKey = 'bannerAnchor';

  const selectedAnchor = context.getConfig(selectedAnchorKey) || '';

  const onSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    setIsLoading(true);
    setError('');

    const formData = new FormData(event.target as HTMLFormElement);
    const formProps: any = Object.fromEntries(formData as any);
    const designId = window.apm.serialized.designId;

    try {
      const response = await appConfigService.createAnchor(designId, formProps);
      changeValue(response.id);
      setIsOpen(false);
    } catch (e) {
      setError(e as string);
    }

    setIsLoading(false);
  };

  const changeValue = (newValue: string) => {
    context.setConfig(selectedAnchorKey, newValue);
    const nodeId = context.hasWriteProxy()
      ? context.id
      : context.props.parentComponentID;
    window.apm.updateParentNode(
      context,
      nodeId,
      selectedAnchorKey,
      newValue,
      context.type,
      selectedAnchor
    );
    document.dispatchEvent(new CustomEvent('ev-property-refresh'));
  };

  return (
    <>
      <div className="form-component-container buttonModal">
        <button
          className="form-button square"
          type="button"
          onClick={() => setIsOpen(true)}
        >
          +
        </button>
        <label>Create new Banner Anchor</label>
      </div>

      {isOpen && (
        <Modal handleClose={() => setIsOpen(false)} isOpen={isOpen}>
          <Box className="buttonModalContent">
            <h3>Create Anchor</h3>
            <form onSubmit={onSubmit}>
              <fieldset disabled={isLoading}>
                <InputIcon label="Name" name="name" placeholder="Anchor Name" />
                <InputIcon
                  label="Notes"
                  type="textarea"
                  rows={3}
                  name="notes"
                  placeholder="Additional Notes"
                />
              </fieldset>

              {error && <div className="form-errors">{error}</div>}

              <div className="buttonModalContent-actions">
                <fieldset disabled={isLoading}>
                  <Button
                    type="button"
                    onClick={() => setIsOpen(false)}
                    theme="outline"
                    disabled={isLoading}
                  >
                    Cancel
                  </Button>
                  <Button type="submit" disabled={isLoading}>Submit</Button>
                </fieldset>
              </div>
            </form>
          </Box>
        </Modal>
      )}
    </>
  );
};
